export enum ScheduleStatusActionTypes {
    SET_SCHEDULESTATUS = "SET_SCHEDULESTATUS",
    CLEAR_SCHEDULESTATUS = "CLEAR_SCHEDULESTATUS"
}